import {
  Alert,
  GKSearchSelect,
  Grid2,
  InfolconIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "components";
import { Controller, useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";

interface Props {
  fields: any[];
}

const BrokerPortfolioMapping = (props: Props) => {
  const { fields } = props;

  const form = useFormContext();

  const portfolios = useAppSelector((state) => state?.app?.portfolios);

  return (
    <TableContainer>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography fontSize={16} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Alert
                sx={{ mb: 2 }}
                severity="warning"
                icon={<InfolconIcon width={14} height={14} />}
              >
                The Following portfolio codes we have not found in your account,
                please map it to already existing portfolios.
              </Alert>
              {fields.map((item: any, index: number) => (
                <Grid2 size={12} my={1} key={item.id}>
                  <Controller
                    name={`step2.portfolio.${index}.portfolio`}
                    control={form.control}
                    render={({ field }) => (
                      <GKSearchSelect
                        {...field}
                        disableClearable
                        options={portfolios || []}
                        getOptionLabel={(option) => option?.name || option}
                        inputLabel={item?.value}
                        onChange={(e, val) => {
                          field.onChange(val?.value);
                        }}
                        value={
                          portfolios?.find(
                            (data: any) => data.value === field.value,
                          )?.name || ""
                        }
                      />
                    )}
                  />
                </Grid2>
              ))}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BrokerPortfolioMapping;
